import { useState } from 'react';
import { useSiteData } from '@/contexts/SiteDataContext';
import type { OrgInfo } from '@/contexts/SiteDataContext';

export default function OrgInfoSection() {
  const { data, updateOrg } = useSiteData();
  const [form, setForm] = useState<OrgInfo>({ ...data.org });
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    updateOrg(form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-foreground-900 mb-1">Organization Info</h2>
        <p className="text-foreground-500 text-sm">Edit the organization name, tagline, logo, and registration details.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-semibold text-foreground-700 mb-1.5">Organization Name</label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-foreground-700 mb-1.5">Tagline / Subtitle</label>
          <input
            type="text"
            value={form.tagline}
            onChange={(e) => setForm({ ...form, tagline: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-foreground-700 mb-1.5">Registration Number</label>
          <input
            type="text"
            value={form.regNo}
            onChange={(e) => setForm({ ...form, regNo: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-foreground-700 mb-1.5">Logo URL</label>
          <input
            type="text"
            value={form.logoUrl}
            onChange={(e) => setForm({ ...form, logoUrl: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-semibold text-foreground-700 mb-1.5">About Description (Footer & About page)</label>
          <textarea
            rows={4}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 resize-none"
          />
        </div>
      </div>

      {form.logoUrl && (
        <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl border border-background-200">
          <img src={form.logoUrl} alt="Logo preview" className="w-16 h-16 rounded-full object-cover border border-background-200" />
          <div>
            <p className="text-sm font-bold text-foreground-900">{form.name}</p>
            <p className="text-xs text-foreground-500">{form.tagline}</p>
            <p className="text-xs text-accent-600 mt-0.5">Reg. No: {form.regNo}</p>
          </div>
        </div>
      )}

      <button
        onClick={handleSave}
        className={`inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition-all duration-300 whitespace-nowrap ${
          saved ? 'bg-emerald-500 text-white' : 'bg-primary-500 text-white hover:bg-primary-600'
        }`}
      >
        <i className={saved ? 'ri-check-line' : 'ri-save-line'}></i>
        {saved ? 'Saved!' : 'Save Organization Info'}
      </button>
    </div>
  );
}